import type { PublicChecklistsQueryParams } from './types';

/**
 * The wire shape of the query string both public-list endpoints accept.
 *
 * `filter` and `with_disabled` are in the spec too, but nothing in either app has a use for them
 * yet, so they are left off rather than threaded through unused.
 */
export type PublicChecklistsQuery = {
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: string;
  search?: string;
  category_uuid?: string;
};

/**
 * The app's filter state as query parameters.
 *
 * Empty values are dropped rather than sent blank: `search=` narrows nothing but does change the
 * query key, and the client's own encoder only skips `null`/`undefined`, not `''`. A blank search
 * and no search must be the same request, or every keystroke that clears the box costs a fetch.
 *
 * `sort_order` is lowercased on the way out. The endpoint's own description says it lowercases and
 * falls back to `asc`, so `DESC` would not 422 — it would silently sort the wrong way (B6).
 */
export const toPublicChecklistsQuery = ({
  page,
  pageSize,
  sortBy,
  sortOrder,
  search,
  categoryUuid,
}: PublicChecklistsQueryParams): PublicChecklistsQuery => {
  const trimmedSearch = search?.trim();

  return {
    ...(page ? { page } : {}),
    ...(pageSize ? { page_size: pageSize } : {}),
    ...(sortBy ? { sort_by: sortBy } : {}),
    ...(sortOrder ? { sort_order: sortOrder.toLowerCase() } : {}),
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
    ...(categoryUuid ? { category_uuid: categoryUuid } : {}),
  };
};
